export const CLEAR = "CLEAR";

export const HAS_PERSONAL_DATA_FORM = "HAS_PERSONAL_DATA_FORM";
export const HAS_PERSONAL_DATA_FORM_FAILURE = "HAS_PERSONAL_DATA_FORM_FAILURE";
export const HAS_PERSONAL_DATA_FORM_SUCCESS = "HAS_PERSONAL_DATA_FORM_SUCCESS";

export const PERSONAL_DATA_PATCH = "PATCH";
export const PERSONAL_DATA_PATCH_FAILURE= "PERSONAL_DATA_PATCH_FAILURE";
export const PERSONAL_DATA_PATCH_SUCCESS = "PERSONAL_DATA_PATCH_SUCCESS";

export const AUTHENTICATE_MEMBER = "AUTHENTICATE_MEMBER";
export const AUTHENTICATE_MEMBER_FAILURE = "AUTHENTICATE_MEMBER_FAILURE";
export const AUTHENTICATE_MEMBER_SUCCESS = "AUTHENTICATE_MEMBER_SUCCESS";


// WEBPACK FOOTER //
// ./src/components/personal-data/personalDataActionTypes.js